import useGetApi from '../useGetApi';
import {
  RexelFileProcessingJob,
  PaginatedResponse,
  ProcessingJobsQuery,
} from './types';

export const useRexelProcessingJobs = (query?: ProcessingJobsQuery) => {
  return useGetApi<PaginatedResponse<RexelFileProcessingJob>>({
    endpoint: 'rexel/processing-jobs',
    queryParameters: query,
    queryKey: ['rexel', 'processing-jobs', query],
    options: {
      staleTime: 30 * 1000, // 30 seconds
      refetchInterval: 60 * 1000, // Refresh every minute
    },
  });
};

export const useRexelProcessingJob = (jobId: string | undefined) => {
  return useGetApi<RexelFileProcessingJob>({
    endpoint: `rexel/processing-jobs/${jobId}`,
    queryKey: ['rexel', 'processing-jobs', jobId],
    options: {
      enabled: !!jobId,
      staleTime: 30 * 1000,
      refetchInterval: 30 * 1000, // Refresh every 30 seconds for individual job
    },
  });
};
